export default __webpack_public_path__ + "static/Shilpi-e6c815fc4bdfe02efb4327590d6728c2.png";